
import Spinner from '~/js/components/general/Spinner';
import ReviewSlider from '~/js/components/global/reviews/ReviewSlider';

const { Component, Fragment } = React;

class ReviewPanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      reviews: [],
      loading: true
    };

    this.abortController = new window.AbortController();
  }

  componentDidMount() {
    this.mounted = true;
    const reviewId = this.props.urlReviews.reviewId;
    const propsHasReviewId = reviewId != null || reviewId != undefined

    const fetchReviews = (resort, index) => {
      const url = propsHasReviewId ?
      `/fecthReviews/?resortCode=${resort.code}&reviewId=${reviewId}&startRow=1&endRow=5&showOnlyWeb=N` :
      `/fecthReviews/?resortCode=${resort.code}&startRow=1&endRow=5`;

      fetch(url, { signal: this.abortController.signal })
        .then((response) => response.json())
        .then((json) => {
          if(this.mounted) {
            const review = json.data.resortReviews[0] != undefined ? json.data.resortReviews[0] : null;
            const id = `${index}-${(resort.code).toLowerCase()}-review`;
            
            if(propsHasReviewId) {
              this.setState((prevState) => ({
                reviews: [
                  ...prevState.reviews,
                  {
                    id: id,
                    resortCode: resort.code,
                    resortName: resort.shortName,
                    resortCountry: resort.countryName,
                    resortCity: resort.city,
                    resortUrl: resort.url.replace("https://www.beaches.com", ""),
                    resortImages: resort.images,
                    body: review != null ? review.body : "",
                    postage: review != null ? review.postage : "",
                    rating: review != null ? review.rating : 0,
                    reviewSite: review !=null ? review.reviewSite : "",
                    title: review != null ? review.title : "No reviews yet",
                  },
                ],
                loading: false,
              }));
            }
            else {
              this.setState((prevState) => ({
                reviews: [...prevState.reviews.concat(...json.data.resortReviews.map(review => {
                  return {
                    id: id,
                    resortCode: resort.code,
                    resortName: resort.shortName,
                    resortCountry: resort.countryName,
                    resortCity: resort.city,
                    resortUrl: resort.url.replace("https://www.beaches.com", ""),
                    resortImages: resort.images,
                    body: review != null ? review.body : "",
                    postage: review != null ? review.postage : "",
                    rating: review != null ? review.rating : 0,
                    reviewSite: review !=null ? review.reviewSite : "",
                    title: review != null ? review.title : "No reviews yet",
                  };
                }))],
                loading: false,
              }));
            }
          }
        })
        .catch((error) => {
          console.log(error.message);
          if(error.name === 'AbortError') {return;}
          throw error;
        });
    };

    this.props.resorts.map((resort, index)  => {
      fetchReviews(resort, index);
    });
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  render() {
    const { reviews, loading } = this.state;
    const { urlReviews } = this.props;


    return (
      <Fragment>
        {loading && (
          <Spinner className="guest-reviews__spinner" />
        )}
        {!loading && (
          <ReviewSlider
            reviews={reviews}
            urlReviews={urlReviews}
          />
        )}
      </Fragment>
    );
  }


}

export default ReviewPanel;
